module.exports = __webpack_public_path__ + "img/sashimifrontal.5aebf7ff.jpg";